import { Link } from "react-router-dom";
import type { FailArticle } from "@/mocks/articles";

export default function TimelineBlock({ items }: { items: FailArticle["timeline"] }) {
  return (
    <section aria-labelledby="timeline-title" className="w-full">
      <h2 id="timeline-title" className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-6 flex items-center gap-2">
        <span className="w-8 h-8 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center">
          <i className="ri-time-line"></i>
        </span>
        事件时间线
      </h2>
      <ol className="relative pl-1">
        {items.map((item, index) => (
          <li key={item.time} className="relative flex gap-4 pb-6 last:pb-0">
            <div className="flex flex-col items-center">
              <span
                className={`w-3 h-3 rounded-full mt-1.5 shrink-0 ${
                  index === 0 ? "bg-primary-500 ring-4 ring-primary-100" : "bg-secondary-400"
                }`}
              ></span>
              {index < items.length - 1 && <span className="flex-1 w-px bg-background-300 mt-1"></span>}
            </div>
            <div className="flex-1 pb-1">
              <span className="inline-block px-2 py-0.5 rounded bg-background-100 border border-background-200 text-xs font-medium text-foreground-700">
                {item.time}
              </span>
              <p className="mt-2 text-sm md:text-base leading-relaxed text-foreground-700">{item.text}</p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}